<template>
    <teleport to="#destination-toast">
        <div
            class="toast-wrap"
            v-if="props.isOpen"
            :class="{ active: isActive }"
            :style="wrapStyle"
            @click="handleClickToast"
            role="dialog"
            aria-modal="true"
        >
            <p class="toast-text" :style="{ color: props.textColor }">
                {{ props.title }}
            </p>
        </div>
    </teleport>
</template>

<script setup lang="ts">
import { computed, ref, onUnmounted, watch } from 'vue';
import { isAppleDevice } from '@common/common/utils/utils';

const props = defineProps({
    isOpen: {
        type: Boolean,
        default: false,
    },
    title: {
        type: String,
        default: '',
    },
    textColor: {
        type: String,
        default: '#21242E',
    },
});

const emit = defineEmits(['close']);

const isActive = ref(false);
const timer = ref<ReturnType<typeof setTimeout> | null>(null);

// iOS는 상단 헤더/상태바 영역이 더 높으므로 기본 top(70px)에 50px을 추가로 내림
const wrapStyle = computed(() => (isAppleDevice() ? { top: '120px' } : {}));

const handleClickToast = () => {
    emit('close');
};

watch(
    () => props.isOpen,
    newVal => {
        if (newVal) {
            isActive.value = false;

            timer.value = setTimeout(() => {
                isActive.value = true;

                timer.value = setTimeout(() => {
                    isActive.value = false;

                    // 트랜지션 끝나고 나서 emit
                    timer.value = setTimeout(() => {
                        handleClickToast();
                    }, 300); // <- transition 시간과 동일하게
                }, 3000);
            }, 100);
        }
    },
);

onUnmounted(() => {
    if (timer.value) {
        clearTimeout(timer.value);
    }
});
</script>

<style scoped lang="scss">
.toast-wrap {
    position: fixed;
    top: 70px;
    left: 0;
    z-index: 9999;
    margin: 0 1.5rem;
    width: calc(100% - 3rem);
    padding: 1.7rem 0;
    background-color: $grey-1;
    border-radius: 1rem;
    border: 1px solid $grey-3;
    box-shadow: 0px 10px 20px 0px #6069760d;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.6rem;
    line-height: 150%;
    font-weight: 500;
    color: $primary-black;
    transform: translateY(-100%);
    opacity: 0;
    transition: all 0.3s ease-in-out;

    &.active {
        transform: translateY(1.5rem);
        opacity: 1;
        transition: all 0.3s ease-in-out;
    }
}
</style>
